// extracted by mini-css-extract-plugin
export var active = "_hp-2";
export var recordingDot = "_hp-1";
export var recordingIndicator = "_hp-0";